import React, { Component } from 'react';
import { Form, Input, Select, Upload, Icon, message, Switch, Button, DatePicker } from 'antd';
import { connect } from 'react-redux';

import { getCategories, uploadFile } from '../../../../../actions';
import { API_URL } from '../../../../../utils/constants';
import {  isArticleManager, isReporter, isAny, isNone, isAnnouncer} from '../../../../../utils/roles';

const FormItem = Form.Item;
const Option = Select.Option;

const EditorForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },

  mapPropsToFields(props) {
    return {
      newTitle: Form.createFormField({
        ...props.newTitle,
        value: props.newTitle.value,
      }),
      newCreatedAt: Form.createFormField({
        ...props.newCreatedAt,
        value: props.newCreatedAt.value,
      }),
      newCategory: Form.createFormField({
        ...props.newCategory,
        value: props.newCategory.value,
      }),
      newLanguage: Form.createFormField({
        ...props.newLanguage,
        value: props.newLanguage.value,
      }),
    };
  },

  // onValuesChange(_, values) {
  //   console.log(values);
  // },
})(class extends Component {
  componentDidMount = () => {
    this.props.getCategories();
  }

  handleUploadAttachment = (info) => {
    const { newAttachments } = this.props;
    if (info.file.status === 'uploading') {
      if (!info.event) {
        message.loading(`Đang tải lên tệp ${info.file.originFileObj ? info.file.originFileObj.name : info.file.name}.`);
        this.props.onChange({
          newAttachments: {
            value: [
              ...newAttachments.value,
              {
                uid: info.file.uid,
                name: info.file.originFileObj ? info.file.originFileObj.name : info.file.name,
                status: info.file.status,
                url: '',
              },
            ],
          },
        });
      }
    } else if (info.file.status === 'done' && info.file) {
      this.props.onChange({
        newAttachments: {
          value: newAttachments.value.map(at => (at.uid === info.file.uid
            ? { ...at, status: info.file.status, url: info.file.response.location }
            : at)),
        },
      });
      message.success(`Tệp ${info.file.response.originalname} được tải lên thành công.`);
    } else if (info.file.status === 'error') {
      message.error('Tải lên thất bại.');
      this.props.onChange({
        newAttachments: {
          value: [
            ...newAttachments.value.splice(0, -1),
          ],
        },
      });
    } else if (info.file.status === 'removed') {
      this.props.onChange({
        newAttachments: {
          value: newAttachments.value.filter(item => item.uid !== info.file.uid),
        },
      });
    }
  }

  handleUploadImage = (file) => {
    const validImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!validImage) {
      message.error('Chỉ được tải lên định dạng JPG hoặc PNG!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Kích thước ảnh phải nhỏ hơn 2MB!');
    }
    if (validImage && isLt2M) {
      this.props.uploadFile({ file, type: 'newFeaturedImage', key: 'post' }, this.props.onChange);
    }
    return false;
  }

  beforeUploadAttachment = (file) => {
    const validFile = true; //file.type === 'application/pdf';
    if (!validFile) {
      message.error('Dinh dang file khong cho phep');
    }
    const isLt2M = file.size / 1024 / 1024 < 200;
    if (!isLt2M) {
       message.error('Kích thước tệp phải nhỏ hơn 200MB!');
    }
    return (validFile && isLt2M);
  }
  
  render() {
    const {
      form: { getFieldDecorator },
      upload,
      category,
      formItemLayout,
      newFeaturedImage,
      newHighlight,
      newIsAnnouncement,
      userInfo,
      newAttachments,
      newCategory,
    } = this.props;
    const image = newFeaturedImage.value || (upload.key === 'post' && upload.file && upload.file.location);
    const isAnnouncement = (newIsAnnouncement && newIsAnnouncement.value) || false;
    const checked = (newHighlight && newHighlight.value) || false;
    let categories = [];
    categories = category.categories.filter(cate => {
      //get categories with this role specified
      let isOK = false;
      userInfo.role.forEach(r => {
        if (cate.roles.indexOf(r) > -1) {
          isOK = true;
        }
      });
      return ((newCategory.value && newCategory.value._id ===  cate._id) 
                || isArticleManager(userInfo.role) ||  (cate.roles.indexOf(isAny)>-1) || 
                ((isReporter(userInfo.role)  || isOK ) && (cate.roles.indexOf(isNone) === -1))
                );
    });

    const uploadAttachmentsProps = {
      name: 'file',
      action: `${API_URL}/upload/`,
      headers: {
        Authorization: userInfo.token,
      },
      onChange: this.handleUploadAttachment,
      fileList: newAttachments.value,
      beforeUpload: this.beforeUploadAttachment,
    };

    return (
      <Form>
        <FormItem
          {...formItemLayout}
          label="Tiêu đề"
        >
          {getFieldDecorator('newTitle')(
            <Input placeholder="Tiêu đề không được bỏ trống" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Danh mục"
        >
          <Select
            defaultValue={newCategory.value ? newCategory.value._id : null}
            onChange={value => this.props.onChange({ newCategory: { value } })}
          >
            {categories.map(item => (
              <Option key={item._id} value={item._id}>{item.name}</Option>
            ))}
          </Select>
        </FormItem>
        <FormItem {...formItemLayout} label="Ngôn ngữ">
          {isAnnouncer(userInfo.role) ? getFieldDecorator('newLanguage')(
            <Select placeholder="Chọn ngôn ngữ">
              <Option key={0} value='vi'>Tiếng Việt</Option>
              <Option key={1} value='en'>English</Option>
            </Select>
          ) : getFieldDecorator('newLanguage')(
            <Select placeholder="Chọn ngôn ngữ">
              <Option key={0} value='vi'>Tiếng Việt</Option>
            </Select>
          )}
        </FormItem> 
        <FormItem
          {...formItemLayout}
          label="Thông báo"
        >         
          {/* {getFieldDecorator('newHighlight', { valuePropName: 'checked' })( */}
          {isAnnouncer(userInfo.role) ? 
          <Switch checked={isAnnouncement} onChange={c => this.props.onChange({ newIsAnnouncement: { value: c } })} />
          : 'Không có quyền đưa tin ra thông báo'
          }
          {/* )} */}         
        </FormItem>
        
        <FormItem
          {...formItemLayout}
          label="Nổi bật"
        >
          {/* {getFieldDecorator('newHighlight', { valuePropName: 'checked' })( */}
          <Switch checked={checked} onChange={c => this.props.onChange({ newHighlight: { value: c } })} />
          {/* )} */}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Ảnh bìa"
        >
          <Upload
            name="avatar"
            listType="picture-card"
            className="cover-uploader"
            showUploadList={false}
            beforeUpload={this.handleUploadImage}
          >
            {image
              ? <img style={{ width: 228, height: 128, objectFit: 'cover' }} src={image} alt="featuredimage" />
              : <div>
                <Icon type={upload.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">Tải lên</div>
              </div>}
          </Upload>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Tệp đính kèm"
        >
          <Upload {...uploadAttachmentsProps}>
            <Button>
              <Icon type="upload" /> Tải lên
            </Button>
          </Upload>
        </FormItem>
        <FormItem {...formItemLayout} label="Ngày đăng">
          {getFieldDecorator('newCreatedAt')(
            <DatePicker showTime format="DD-MM-YYYY HH:mm" />,
          )}
        </FormItem>
      </Form>
    );
  }
});

export default connect(state => ({
  userInfo: state.user.info,
  upload: state.upload,
  category: state.category,
}), {
  getCategories,
  uploadFile,
})(EditorForm);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Posts/Editor/EditorForm.js